<template>
    <div class="formScreen">
        <el-form class="custom-out-form" :model="formScreen" label-width="100px" inline ref="formScreen">
            <el-row type="flex" justify="space-between">

                <el-col :span="6">
                <el-form-item label="分公司" prop="branchCompanyId">
                    <el-select v-model="formScreen.branchCompanyId" filterable placeholder="请选择" @change="selectChange">
                        <el-option
                            v-for="item in formData.listBranch"
                            :key="item.id"
                            :label="item.companyFullName"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                </el-col>
                
                <el-col :span="6">
                <el-form-item label="子公司" prop="companyId">
                    <el-select v-model="formScreen.companyId" filterable placeholder="请选择">
                        <el-option
                            v-for="item in formData.listSon"
                            :key="item.id"
                            :label="item.companyFullName"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                </el-col>

                <el-col :span="6">
                <el-form-item label="开始日期" prop="startTimeString">
                    <el-date-picker
                        v-model="formScreen.startTimeString"
                        align="right"
                        type="datetime"
                        placeholder="选择开始日期"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
                </el-col>

                <el-col :span="6">
                <el-form-item label="结束日期" prop="endTimeString">
                    <el-date-picker
                        v-model="formScreen.endTimeString"
                        align="right"
                        type="datetime"
                        placeholder="选择结束日期"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex">
                <el-col :span="6">
                <el-form-item label="审核状态" prop="checkResult" v-if="pageType !== 'server'">
                    <el-select v-model="formScreen.checkResult" placeholder="请选择">
                        <el-option
                            v-for="item in listExamine"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="处理状态" prop="exceptionResult" v-else>
                  <el-select v-model="formScreen.exceptionResult" placeholder="请选择">
                    <el-option
                        v-for="item in listExamine2"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                </el-col>

                <el-col :span="12">
                <div class="search-box">
                    <el-form-item label=" " prop="searchString">
                        <el-input style="width:100%;" v-model.trim="formScreen.searchString" :placeholder="`订单号、订单ID${placeholder}`"></el-input>
                    </el-form-item>
                    <el-button type="primary" @click="queryForm">搜索</el-button>
                    <el-button type="primary" @click="resetForm">重置</el-button>
                </div>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from "@/api/api/api";

export default {
    name: "formScreen",
    props: {
        formData: {
            type: Object,
            default() {
                return {};
            },
        },
        pageType: String,
        placeholder: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            listExamine: [
                {
                    value: "0",
                    label: "未审核",
                },
                {
                    value: "1",
                    label: "审核通过",
                },
            ],
            listExamine2: [
              { value: 0, label: '未处理' },
              { value: 1, label: '申请退件' },
              { value: 2, label: '确认退件' },
              { value: 3, label: '申请转库存' },
              { value: 4, label: '确认转库存' },
              { value: 5, label: '申请取消异常' },
              { value: 6, label: '确认取消异常' },
              { value: 7, label: '已退件' },
              { value: 9, label: '申请转未知' },
              { value: 10, label: '确认转未知' },
            ],
            formScreen: {
                branchCompanyId: "",
                companyId: "",
                startTimeString: "",
                endTimeString: "",
                searchString: "",
                checkResult: "",
                type: "",
            },
        };
    },
    methods: {
        queryForm(type) {
            this.$emit("confirm", this.formScreen, type);
        },
        resetForm() {
            this.$refs.formScreen.resetFields();
            this.$emit("resetSonCompany");
            this.queryForm("reset");
        },
        getBranchCompanyList() {
            const API = Baseurl + "logisticsController/getAllBranchCompany";
            ajaxPost(API).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.formData.listBranch = data;
                }
            });
        },
        selectChange(id) {
            this.$emit("resetSonCompany");
            this.formScreen.companyId = "";
            this.$emit("formChange", id);
        },
    },
};
</script>

<style lang="scss" scoped>
.formScreen {
    .custom-out-form {
        .el-form-item {
            margin: 0;
        }
        .search-box {
            display: flex;
            align-items: center;
            .el-form-item {
                margin-right: 10px;
            }
            /deep/ .el-form-item__content {
                width: 300px;
            }
        }
    }
}
</style>
